import { type Conversation } from '@avanta/shared/types/chat';
import { Category } from '../Category';
import { Channel } from '../Channel';

interface ConversationListProps {
  conversations: Conversation[];
  title: string;
}

export const ConversationList = ({
  conversations,
  title,
}: ConversationListProps): React.ReactElement | null => {
  if (conversations.length === 0) return null;

  return (
    <Category title={title}>
      {conversations.map(chat => (
        <Channel
          key={chat.channel.id}
          channelId={chat.channel.id}
          title={chat.otherUser.name ?? ''}
          unreadMessages={chat.unreadCount}
        />
      ))}
    </Category>
  );
};
